import { FlatfileClient } from "@flatfile/api";
import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

/**
 * Id of the Flatfile sheet holding the uploaded spreadsheet rows of the given
 * batch.
 *
 * A space holds two workbooks: the pinned one with the main data sheet the user
 * uploads into ("payables"/"contractors"), and "Wingspan Internal" with the
 * `*-rejections` and `*-logs` sheets. Only the latter is recorded in the space
 * metadata (`wsInternalWorkbookId`), so the main sheet is found by slug across
 * every workbook of the space instead.
 */
export async function getFlatfileMainSheetId(
  flatfileApiClient: FlatfileClient,
  batch: Batch,
  sheetSlug: string
): Promise<string> {
  const spaceId = batch.metadata?.[BATCH_LABELS_WS_KEYS.flatfileBatchId];

  if (!spaceId) {
    throw new Error("No Flatfile space for this batch");
  }

  const { data: workbooks } = await flatfileApiClient.workbooks.list({
    spaceId
  });
  const mainSheet = workbooks
    .flatMap(workbook => workbook.sheets ?? [])
    .find(sheet => sheet.slug === sheetSlug);

  if (!mainSheet) {
    throw new Error(
      `Flatfile sheet "${sheetSlug}" not found in space ${spaceId}`
    );
  }

  return mainSheet.id;
}
